<template>
  <el-card class="account-card" shadow="hover" @click="emits('arrowRigh')">
    <div class="card-content">
      <!-- 左侧图标 -->
      <div class="icon-section">
        <i :class="[backgroundIcon, 'coin-icon']"></i>
        <div class="icon-glow"></div>
      </div>

      <!-- 右侧信息 -->
      <div class="points-info">
        <div class="value">
          <el-tooltip
            content="积分数据有时会有延迟，如果长时间未更新，请手动刷新界面"
            placement="top"
            effect="light"
          >
            <i class="ri-information-line info-icon"></i>
          </el-tooltip>
          {{ formatNumber(availableRechargeBalance) }}
        </div>
        <div class="label">
          <span>{{ labelText }}</span>
          <el-icon v-if="arrowRighBtn" class="arrow-icon">
            <ArrowRight />
          </el-icon>
        </div>
      </div>
    </div>
  </el-card>
</template>

<script setup>
import { defineProps, defineEmits } from 'vue'
import { ArrowRight } from '@element-plus/icons-vue'

const props = defineProps({
  availableRechargeBalance: {
    type: [String, Number],
    default: 1
  },
  arrowRighBtn: {
    type: Boolean,
    default: true
  },
  labelText: {
    type: String,
    default: '剩余积分'
  },
  buttonIcon: {
    type: String,
    default: 'ri-arrow-right-up-fill'
  },
  backgroundIcon: {
    type: String,
    default: 'ri-coin-fill'
  }
});

const emits = defineEmits(['arrowRigh'])
// - K (Kilo) = 千，表示1000
// - M (Million) = 百万，表示1000000
const formatNumber = (num) => {
  // if (num >= 1000000) {
  //   return (num / 1000000).toFixed(1) + 'M'
  // } else if (num >= 1000) {
  //   return (num / 1000).toFixed(1) + 'K'
  // }
  return num
}
</script>

<style lang="scss" scoped>
.account-card {
  width: 100%;
  background: var(--dark-component-bg-color-1);
  border: 1px solid var(--dark-component-bg-color-1);
  cursor: pointer;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  border-radius: 8px;

  &:hover {
    transform: translateY(-3px);
    background: var(--dark-component-bg-color-3);

    .coin-icon {
      transform: scale(1.15) rotate(15deg);
    }

    .icon-glow {
      opacity: 1;
      transform: scale(1.2);
    }

    .arrow-icon {
      transform: translateX(6px);
    }
  }

  :deep(.el-card__body) {
    padding: 8px;
    box-sizing: border-box;
  }

  .card-content {
    display: grid;
    grid-template-columns: auto minmax(0, 1fr);
    gap: 16px;
    align-items: center;
  }

  .icon-section {
    position: relative;
    width: 48px;
    height: 48px;
    border-radius: 16px;
    background: var(--dark-component-bg-color-4);
    display: flex;
    align-items: center;
    justify-content: center;

    .coin-icon {
      font-size: 26px;
      background: var(--dark-gradient-primary);
      -webkit-background-clip: text;
      background-clip: text;
      -webkit-text-fill-color: transparent;
      z-index: 1;
    }
  }

  .points-info {
    min-width: 0;

    .value {
      font-size: 20px;
      font-weight: 600;
      background: var(--dark-gradient-primary);
      -webkit-background-clip: text;
      background-clip: text;
      -webkit-text-fill-color: transparent;
      line-height: 1.2;
      margin-bottom: 4px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      display: flex;
      align-items: center;
      gap: 3px;

      .info-icon {
        font-size: 16px;
        color: rgba(255, 255, 255, 0.7);
        cursor: pointer;
        transition: color 0.3s;
        -webkit-text-fill-color: rgba(255, 255, 255, 0.7);
        font-weight: 300 !important;

        &:hover {
          color: rgba(255, 255, 255, 1);
          -webkit-text-fill-color: rgba(255, 255, 255, 1);
        }
      }

      @media (max-width: 768px) {
        font-size: 24px;
      }
    }

    .label {
      display: flex;
      align-items: center;
      gap: 6px;
      color: rgba(255, 255, 255, 0.85);
      font-size: 13px;
      white-space: nowrap;

      .arrow-icon {
        flex-shrink: 0;
        font-size: 14px;
        transition: transform 0.4s cubic-bezier(0.4, 0, 0.2, 1);
      }
    }
  }
}

:deep(.el-card) {
  --el-card-bg-color: transparent;
  --el-card-border-color: transparent;
}
</style>